import { render, staticRenderFns } from "./AlunosCadastradosModal.vue?vue&type=template&id=1d0463c2&scoped=true"
import script from "./AlunosCadastradosModal.vue?vue&type=script&lang=js"
export * from "./AlunosCadastradosModal.vue?vue&type=script&lang=js"
import style0 from "./AlunosCadastradosModal.vue?vue&type=style&index=0&id=1d0463c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0463c2",
  null
  
)

export default component.exports